module.exports = __webpack_public_path__ + "assets/img/banner-9.a3ded884.png";